SetDesign(function($, _, window, document) {
    var addAction = SetDesign.addAction;
    var applyFilters = SetDesign.applyFilters;
    var doAction = SetDesign.doAction;
    var GA_EVENT = SetDesign.GA_EVENT;
    var GTM_INTERACTION = SetDesign.GTM_INTERACTION;
    var GTM_STATE = SetDesign.GTM_STATE;
    var dataLayer = window.dataLayer = window.dataLayer || [];
    var getContext = function($el) {
        return $el.parents("[data-gtm], [id], [aria-label], [aria-labelledby]").map(function() {
            var $this = $(this);
            return $this.data("gtm") || $this.attr("id") || $this.attr("aria-label") || $("#" + $this.attr("aria-labelledby")).text() || null
        }).get().reverse()
    };
    $(document).on("click", "[data-ga-event]", function(e) {
        if (!applyFilters("gtm/disable-ga-click", false)) {
            doAction(GA_EVENT, SetDesign.splitStr($(this).data("gaEvent")))
        }
    });
    $(document).on("click", "a, button, input:submit, [data-button]", function(e) {
        var $this = $(this);
        if ($this.data("gtm") !== 0 && $this.data("gtm") !== false) {
            doAction(GTM_INTERACTION, this)
        }
    });
    $(document).bind("gform_confirmation_loaded", _.debounce(function(e, formId) {
        var $el = $("#gform_confirmation_wrapper_" + formId);
        doAction(GTM_INTERACTION, {
            type: "submit",
            formID: formId,
            success: true,
            $el: $el
        })
    }, 500));
    addAction(SetDesign.HASH_STATE_CHANGE, function(state) {
        doAction(GTM_STATE, {
            currentHash: state.current
        })
    });
    addAction("showModal", function($modal) {
        var id = $modal.attr("id");
        var label = $modal.find("#" + $modal.attr("aria-labelledby")).text() || id;
        doAction(GTM_INTERACTION, {
            type: "modal-open",
            label: label,
            destination: "#" + id
        })
    });
    addAction("hideModal", function($modal) {
        var id = $modal.attr("id");
        var label = $modal.find("#" + $modal.attr("aria-labelledby")).text() || id;
        doAction(GTM_INTERACTION, {
            type: "modal-close",
            label: label,
            destination: "#" + id
        })
    });
    addAction(GA_EVENT, function(eventData) {
        dataLayer.push({
            event: "gaEvent",
            gaEvent: {
                category: eventData[0],
                action: eventData[1],
                label: eventData[2]
            }
        })
    });
    addAction(GTM_INTERACTION, function(interactionObj) {
        var $el = [];
        if (!$.isPlainObject(interactionObj)) {
            $el = $(interactionObj);
            interactionObj = {}
        } else if (interactionObj.hasOwnProperty("$el")) {
            $el = interactionObj.$el;
            delete interactionObj.$el
        }
        var defaultInteraction = {
            type: "click"
        };
        setTimeout(function() {
            if ($el.length) {
                var dataAttr = $el.data("gtm");
                var override = {};
                var label = "";
                if ($.isPlainObject(dataAttr)) {
                    override = dataAttr
                } else {
                    label = dataAttr
                }
                defaultInteraction.label = label || $el.attr("aria-label") || $("#" + $el.attr("aria-labelledby")).text() || $el.attr("title") || $el.attr("value") || $el.text().trim();
                defaultInteraction.context = getContext($el);
                if ($el.attr("href")) {
                    defaultInteraction.direction = $el[0].host !== window.location.host ? "outbound" : "internal";
                    defaultInteraction.destination = $el.attr("href").replace(window.location.protocol + "//" + window.location.host, "");
                    defaultInteraction.target = defaultInteraction.destination
                }
                var toggleAttributes = [$el.attr("aria-pressed"), $el.attr("aria-expanded")].filter(Boolean);
                if (toggleAttributes.length) {
                    var toggleState = toggleAttributes[0];
                    defaultInteraction.toggle = toggleState.toLowerCase().trim() === "true" || parseInt(toggleState) === 1
                }
                interactionObj = $.extend(interactionObj, override)
            }
            interactionObj = $.extend({}, defaultInteraction, interactionObj);
            dataLayer.push({
                event: "interaction",
                interaction: interactionObj
            });
            dataLayer.push({
                event: "",
                interaction: undefined
            })
        }, 5)
    });
    addAction(GTM_STATE, function(interactionObj) {
        var reset = {};
        for (var key in interactionObj) {
            if (interactionObj.hasOwnProperty(key) && ($.isPlainObject(interactionObj[key]) || $.isArray(interactionObj[key]))) {
                reset[key] = undefined
            }
        }
        if (!$.isEmptyObject(reset)) {
            dataLayer.push({
                state: reset
            })
        }
        dataLayer.push({
            state: interactionObj
        })
    });
    $(window).on("load", function() {
        SetDesign.scrollWatch($(applyFilters("gtm/scroll", $())).add("[data-gtm-scroll]").add($("footer").last()), function() {
            doAction(GTM_INTERACTION, {
                $el: $(this),
                type: "scroll-view"
            })
        })
    })
});
SetDesign(SetDesign.READY, function($, _, window, document) {
    $('a[href*="telecharge.com"]').each(function() {
        var originalUrl = $(this).attr("href");
        var modifiedUrl = SetDesign.mergeUTMParams(originalUrl);
        $(this).attr("href", modifiedUrl)
    });
    $(document).one("TicketCalendar.init", function(e, TicketCalendar, $on) {
        $on(TicketCalendar.FILTER_DEFAULTS, function(defaults) {
            defaults.update({
                "filter-url": function(url) {
                    var deferred = $.Deferred();
                    (function() {
                        var modifiedUrl = url.indexOf("telecharge.com") !== -1 ? SetDesign.mergeUTMParams(url) : url;
                        deferred.resolve(modifiedUrl)
                    })();
                    return deferred.promise()
                }
            })
        })
    })
});
SetDesign(function($, _, window, document) {
    var utmParams = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
    var query = window.location.search.substring(1).split("&");
    var currentUTM = {};
    query.forEach(function(param) {
        var pair = param.split("=");
        var key = decodeURIComponent(pair[0]);
        var value = pair[1] ? decodeURIComponent(pair[1].replace(/\+/g, " ")) : "";
        if (utmParams.indexOf(key) !== -1 && value) {
            currentUTM[key] = value
        }
    });
    if (Object.keys(currentUTM).length > 0) {
        var stored = localStorage.getItem("utm_params");
        var storedUTM = stored ? JSON.parse(stored) : {};
        var mergedUTM = Object.assign({}, storedUTM, currentUTM);
        localStorage.setItem("utm_params", JSON.stringify(mergedUTM))
    }
    SetDesign.mergeUTMParams = function(url) {
        if (typeof url !== "string" || url === "") {
            return ""
        }
        var urlParts = url.match(/^(.*?)(\?([^#]*))?(#(.*))?$/);
        if (!urlParts) {
            return url
        }
        var base = urlParts[1] || "";
        var queryString = urlParts[3] || "";
        var hash = urlParts[5] ? "#" + urlParts[5] : "";
        var nonUTMParams = [];
        var urlUTM = {};
        var params = queryString.split("&");
        for (var i = 0; i < params.length; i++) {
            var param = params[i];
            if (param === "") {
                continue
            }
            var pair = param.split("=");
            var key = decodeURIComponent(pair[0]);
            var value = pair.length > 1 ? decodeURIComponent(pair[1].replace(/\+/g, " ")) : undefined;
            if (utmParams.indexOf(key) !== -1) {
                urlUTM[key] = value || ""
            } else {
                nonUTMParams.push({
                    key: key,
                    value: value
                })
            }
        }
        var storedUTM = localStorage.getItem("utm_params");
        storedUTM = storedUTM ? JSON.parse(storedUTM) : {};
        var mergedUTM = Object.assign({}, urlUTM, storedUTM);
        var mergedUTMParams = [];
        for (var j = 0; j < utmParams.length; j++) {
            var utmKey = utmParams[j];
            if (mergedUTM.hasOwnProperty(utmKey)) {
                mergedUTMParams.push(encodeURIComponent(utmKey) + "=" + encodeURIComponent(mergedUTM[utmKey]))
            }
        }
        var newQueryParts = [];
        for (var k = 0; k < nonUTMParams.length; k++) {
            var paramB = nonUTMParams[k];
            var encodedKey = encodeURIComponent(paramB.key);
            if (paramB.value !== undefined) {
                var encodedValue = encodeURIComponent(paramB.value);
                newQueryParts.push(encodedKey + "=" + encodedValue)
            } else {
                newQueryParts.push(encodedKey)
            }
        }
        newQueryParts = newQueryParts.concat(mergedUTMParams);
        var newQuery = newQueryParts.join("&");
        var finalUrl = base;
        if (newQuery) {
            finalUrl += "?" + newQuery
        }
        finalUrl += hash;
        return finalUrl
    }
});